<nav id="navbar" class="navbar navbar-expand-lg">
    <div class="container-fluid navbar-container">
        <a class="navbar-brand" href="{{ ftepUrl }}" target="_blank">
            <img src="assets/images/logo.png" alt="Forestry TEP Logo">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item" ngClass="{'active': isActive('#/')}">
              <p><a class="nav-link" aria-current="page" routerLink="/">
                    <i class="material-icons navicon nav-item-content">public</i><span class="navbar-text nav-item-content"> Explorer</span>
                </a></p>
            </li>
            <li class="nav-item" ngClass="{'active': isActive('#/files')}">
              <p><a class="nav-link" routerLink="/files">
                <i class="material-icons navicon nav-item-content">folder</i><span class="navbar-text nav-item-content"> Files</span>
                </a></p>
            </li>
            <li class="nav-item" *ngIf="!userService.userInfo">
                <p><a class="nav-link" (click)="userService.login()">
                  <i class="material-icons navicon nav-item-content">power_settings_new</i><span class="navbar-text nav-item-content"> Login</span>
                </a></p>
            </li>
            <li class="nav-item" *ngIf="userService.userInfo">
              <p><a class="nav-link" (click)="userService.logout()">
                <i class="material-icons navicon nav-item-content">power_settings_new</i><span class="navbar-text nav-item-content"> Logout</span>
                </a></p>
            </li>
            <li class="nav-item">
                <p><a class="nav-link" href="https://applicationhub.{{ domain }}/hub/home" target="_blank">
                    <i class="material-icons navicon nav-item-content">build</i><span class="navbar-text nav-item-content"> Developer</span>
                </a></p>
            </li>
            <li class="nav-item">
                <p><a class="nav-link" href="{{ helpdeskUrl }}" target="_blank">
                    <i class="material-icons navicon nav-item-content">help</i><span class="navbar-text nav-item-content"> Helpdesk</span>
                </a></p>
            </li>
          </ul>
        </div>
    
<!--
        <div class="navbar-header">
            <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-contents" aria-expanded="false" aria-controls="navbar">
                <span class="sr-only">Toggle</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>

            <a class="pull-left" href="{{ftepUrl}}" target="_blank">
                <img src="assets/images/logo.png" alt="Forestry TEP Logo">
            </a>
        </div>

        <div class="navbar-contents collapse navbar-collapse">

            <ul class="nav navbar-nav">
                <li routerLink="/" aria-label="Explorer" ng-class="{ active: isActive('/')}">
                    <p><i class="material-icons">public</i><span> Explorer</span></p>
                </li>

                <li routerLink="/files" aria-label="Files " ng-class="{ active: isActive('/files')}">
                    <p><i class="material-icons">folder</i><span> Files</span></p>
                </li>


                <li ng-click="goTo('/developer')" ng-if="user.name" aria-label="Developer" ng-class="{ active: isActive('/developer')}">
                    <p><i class="material-icons">build</i><span> Developer</span></p>
                </li>

                <li ng-click="goTo('/community')" ng-if="user.name" aria-label="Manage " ng-class="{ active: isActive('/community')}">
                    <p><i class="material-icons">person</i><span> Manage / Share</span></p>
                </li>

                <li ng-click="goTo('/admin')" ng-if="user.name && user.role === 'ADMIN'" aria-label="Admin" ng-class="{ active: isActive('/admin')}">
                   <p><i class="material-icons">settings</i><span> Admin</span></p>
                </li>

                <li ng-click="goTo('/account')" ng-if="user.name" aria-label="Account" ng-class="{ active: isActive('/account')}">
                   <p><i class="material-icons">account_circle</i><span> My Account</span></p>
                </li>

                <li ng-if="user.name" aria-label="Logout">
                    <a (click)="logout()">
                        <p><i class="material-icons">power_settings_new</i><span> Logout</span></p>
                    </a>
                </li>

                <li aria-label="Helpdesk">
                    <a href="{{helpdeskUrl}}" target="_blank">
                        <p><i class="material-icons">help</i><span> Helpdesk</span></p>
                    </a>
                </li>

            </ul>

        </div>
-->
</div>

</nav>

<div class="ribbon">{{version}}</div>

